/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
  * @author RamaTulasi <rama.tulasi@sollishealth.com> 
  */
import React, { useEffect, useState } from "react";

import { useMsal } from "@azure/msal-react";


import { loginRequest, b2cPolicies } from "./../authConfig";
import {Container} from 'reactstrap';
import LoginHeader from './LoginHeader';
import { useSelector, useDispatch } from 'react-redux';

import { resetMemberDetails } from '../features/memberDetailsSlice';
import { resetAppointments } from '../features/appointmentSlice';
import { getKeyThenIncreaseKey } from "antd/lib/message";
import { PublicClientApplication } from "@azure/msal-browser";
import { useCookies } from 'react-cookie';
import DownloadApp from "./DownloadApp";
import FooterCompliance from "./FooterCompliace";
const Login = () => {
     const [loading, setLoading] = useState(false);
	 const [cookie, setCookie, removeCookie] = useCookies();
	/**
	 * useMsal is hook that returns the PublicClientApplication instance, 
	 * an array of all accounts currently signed in and an inProgress value 
	 * that tells you what msal is currently doing. For more, visit:
	 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/hooks.md
	 */
	const { instance, accounts } = useMsal();
	const dispatch = useDispatch();

	// useEffect(()=>{
	//     instance.loginRedirect(loginRequest).catch(e => {
	//         console.error(e);
	//     });
	// },[])
	const handleLogin = () => {
		setLoading(false);
		instance.loginRedirect(loginRequest)
		.catch(e => {
			console.error(e);
		});
	}
	useEffect(()=>{
		sessionStorage.clear();
		localStorage.clear();
		removeCookie('fx_info',{path:'/'});
		removeCookie('fx_referrer',{path:'/'});
		dispatch(resetAppointments());
       	dispatch(resetMemberDetails());
	}, [loading])

	return (
		<>
			<LoginHeader/>
			<br/>
			<Container className="margin-top-large">
				<a onClick={handleLogin} className="button-action button-active">LOG IN</a>
				<DownloadApp />
			</Container>
			<div className='footer-call'>
                <FooterCompliance />
			</div>
			{
			loading?	
			<div class="stage">
              <div class="dot-pulse"></div>
            </div>:''
			}
		</>
	
			
	);
};
export default Login;